import { Cognito } from './aws.cognito';
import { DynamoDB } from './aws.dynamodb';
import { User } from './user';
import { UserPost } from './user-posts';
import { UserComment } from './comment';
import { UserData } from './user-data';
import { Ladder } from './ladder';
import { UserFeedback } from './user-feedback';


export {
  Cognito,
  DynamoDB,
  User,
  UserPost,
  UserComment,
  UserData,
  Ladder,
  UserFeedback
};



// WEBPACK FOOTER //
// ./src/providers/providers.ts